(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dynarep-compatibility-cross-sell-backup-20260903"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dynarep-ferrofix-cross-sell')) {
    customElements.define(
      'dynarep-ferrofix-cross-sell',
      class DynarepFerroFixCrossSell extends HTMLElement {
        connectedCallback() {
          this.checkbox = this.querySelector('[data-addon-checkbox]');
          this.form = document.getElementById(this.dataset.productFormId);
          this.quantityInput = this.form?.elements.namedItem('quantity');
          this.cartTotal = Number(this.dataset.cartTotal) || 0;
          this.currency = this.dataset.currency || 'EUR';
          this.onSelectionChange = this.onSelectionChange.bind(this);
          this.onQuantityChange = this.onQuantityChange.bind(this);
          this.onFormSubmit = this.onFormSubmit.bind(this);

          this.checkbox?.addEventListener('change', this.onSelectionChange);
          this.quantityInput?.addEventListener('change', this.onQuantityChange);
          this.quantityInput?.addEventListener('input', this.onQuantityChange);
          this.form?.addEventListener('submit', this.onFormSubmit, true);

          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.cartUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refreshCart());
          }

          this.updateAvailability();
          this.renderState();
          this.refreshCart();
        }

        disconnectedCallback() {
          this.checkbox?.removeEventListener('change', this.onSelectionChange);
          this.quantityInput?.removeEventListener('change', this.onQuantityChange);
          this.quantityInput?.removeEventListener('input', this.onQuantityChange);
          this.form?.removeEventListener('submit', this.onFormSubmit, true);
          this.cartUnsubscriber?.();
        }

        onSelectionChange() {
          this.clearCartError();
          this.renderState();
        }

        onQuantityChange() {
          this.updateAvailability();
          this.renderState();
        }

        get productQuantity() {
          const quantity = Number(this.quantityInput?.value) || 1;
          return Math.max(1, quantity);
        }

        getSelectedLineItem(productQuantity = this.productQuantity) {
          if (!this.checkbox?.checked || this.checkbox.disabled) return null;

          return {
            id: this.dataset.addonVariantId,
            quantity: Number(this.dataset.packsPerProduct) * productQuantity,
          };
        }

        async onFormSubmit(event) {
          const crossSellLine = this.getSelectedLineItem();
          if (!crossSellLine || !this.form) return;

          event.preventDefault();
          event.stopImmediatePropagation();

          const productForm = this.form.closest('product-form');
          const submitButton = productForm?.querySelector('[type="submit"]');
          const spinner = productForm?.querySelector('.loading__spinner');
          if (!submitButton || submitButton.getAttribute('aria-disabled') === 'true') return;

          productForm?.handleErrorMessage();
          this.clearCartError();
          submitButton.setAttribute('aria-disabled', 'true');
          submitButton.classList.add('loading');
          spinner?.classList.remove('hidden');

          const formData = new FormData(this.form);
          const variantId = formData.get('id');
          const quantity = Number(formData.get('quantity')) || 1;
          const cart = productForm?.cart || document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          const sections = cart ? cart.getSectionsToRender().map((section) => section.id) : [];
          const requestBody = {
            items: [
              { id: variantId, quantity },
              {
                id: crossSellLine.id,
                quantity: Number(this.dataset.packsPerProduct) * quantity,
              },
            ],
          };

          if (sections.length > 0) {
            requestBody.sections = sections.join(',');
            requestBody.sections_url = window.location.pathname;
            cart.setActiveElement(document.activeElement);
          }

          try {
            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: JSON.stringify(requestBody),
            });
            const cartData = await response.json();

            if (!response.ok || cartData.status) {
              const message = cartData.description || cartData.message || this.dataset.cartErrorMessage;
              productForm?.handleErrorMessage(message);
              this.showCartError(message);

              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'dynarep-ferrofix-cross-sell',
                  productVariantId: variantId,
                  errors: cartData.errors || message,
                  message,
                });
              }
              return;
            }

            if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              await publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'dynarep-ferrofix-cross-sell',
                productVariantId: variantId,
                cartData,
              });
            }

            cart.renderContents(cartData);
            await this.refreshCart();
          } catch (error) {
            const message = this.dataset.cartErrorMessage;
            productForm?.handleErrorMessage(message);
            this.showCartError(message);
            console.error(error);
          } finally {
            submitButton.classList.remove('loading');
            if (cart?.classList.contains('is-empty')) cart.classList.remove('is-empty');
            submitButton.removeAttribute('aria-disabled');
            spinner?.classList.add('hidden');
          }
        }

        updateAvailability() {
          if (!this.checkbox) return;

          const available = this.dataset.addonAvailable === 'true';
          const inventoryManaged = this.dataset.inventoryManaged === 'true';
          const inventoryContinues = this.dataset.inventoryPolicy === 'continue';
          const inventoryQuantity = Number(this.dataset.inventoryQuantity) || 0;
          const requiredQuantity = Number(this.dataset.packsPerProduct) * this.productQuantity;
          const enoughInventory = !inventoryManaged || inventoryContinues || inventoryQuantity >= requiredQuantity;
          const canSelect = available && enoughInventory;

          this.checkbox.disabled = !canSelect;
          if (!canSelect) this.checkbox.checked = false;
          this.querySelector('[data-stock-message]')?.toggleAttribute('hidden', canSelect);
        }

        async refreshCart() {
          try {
            const response = await fetch(window.Shopify.routes.root + 'cart.js');
            if (!response.ok) return;
            const cart = await response.json();
            this.cartTotal = Number(cart.total_price) || 0;
            this.currency = cart.currency || this.currency;
            this.renderState();
          } catch (error) {
            this.renderState();
          }
        }

        renderState() {
          if (!this.checkbox) return;

          const selected = this.checkbox.checked && !this.checkbox.disabled;
          const productQuantity = this.productQuantity;
          const mainTotal = Number(this.dataset.mainPrice) * productQuantity;
          const addonTotal = selected
            ? Number(this.dataset.addonUnitPrice) * Number(this.dataset.packsPerProduct) * productQuantity
            : 0;
          const threshold = Math.max(1, Number(this.dataset.shippingThreshold));
          const projectedTotal = this.cartTotal + mainTotal + addonTotal;
          const missing = Math.max(0, threshold - projectedTotal);
          const progress = Math.min(100, (projectedTotal / threshold) * 100);

          this.dataset.selected = selected ? 'true' : 'false';
          this.querySelector('[data-selection-status]').textContent = selected
            ? this.dataset.statusSelected
            : this.dataset.statusUnselected;
          this.querySelector('[data-projected-total]').textContent = this.formatMoney(projectedTotal);
          this.querySelector('[data-shipping-missing-value]').textContent = this.formatMoney(missing);
          this.querySelector('[data-shipping-threshold]').textContent = this.formatMoney(threshold);

          const progressElement = this.querySelector('[data-shipping-progress]');
          progressElement?.setAttribute('aria-valuenow', String(Math.min(projectedTotal, threshold)));
          this.querySelector('[data-shipping-progress-bar]')?.style.setProperty('--dynarep-progress', `${progress}%`);
          this.querySelector('[data-shipping-missing]')?.toggleAttribute('hidden', missing === 0);
          this.querySelector('[data-shipping-success]')?.toggleAttribute('hidden', missing !== 0);
        }

        formatMoney(cents) {
          return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
            style: 'currency',
            currency: this.currency,
          }).format(cents / 100);
        }

        showCartError(message) {
          const error = this.querySelector('[data-cart-error]');
          if (!error) return;
          error.textContent = message;
          error.hidden = false;
        }

        clearCartError() {
          const error = this.querySelector('[data-cart-error]');
          if (!error) return;
          error.textContent = '';
          error.hidden = true;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dynarep-compatibility-cross-sell-question-backup-20260903"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dynarep-ferrofix-cross-sell')) {
    customElements.define(
      'dynarep-ferrofix-cross-sell',
      class DynarepFerroFixCrossSell extends HTMLElement {
        connectedCallback() {
          this.checkbox = this.querySelector('[data-addon-checkbox]');
          this.surfaceChoices = [...this.querySelectorAll('[data-surface-choice]')];
          this.form = document.getElementById(this.dataset.productFormId);
          this.quantityInput = this.form?.elements.namedItem('quantity');
          this.cartTotal = Number(this.dataset.cartTotal) || 0;
          this.currency = this.dataset.currency || 'EUR';
          this.onSurfaceChange = this.onSurfaceChange.bind(this);
          this.onSelectionChange = this.onSelectionChange.bind(this);
          this.onQuantityChange = this.onQuantityChange.bind(this);
          this.onFormSubmit = this.onFormSubmit.bind(this);

          this.surfaceChoices.forEach((choice) => choice.addEventListener('change', this.onSurfaceChange));
          this.checkbox?.addEventListener('change', this.onSelectionChange);
          this.quantityInput?.addEventListener('change', this.onQuantityChange);
          this.quantityInput?.addEventListener('input', this.onQuantityChange);
          this.form?.addEventListener('submit', this.onFormSubmit, true);

          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.cartUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refreshCart());
          }

          this.updateAvailability();
          this.renderState();
          this.refreshCart();
        }

        disconnectedCallback() {
          this.surfaceChoices.forEach((choice) => choice.removeEventListener('change', this.onSurfaceChange));
          this.checkbox?.removeEventListener('change', this.onSelectionChange);
          this.quantityInput?.removeEventListener('change', this.onQuantityChange);
          this.quantityInput?.removeEventListener('input', this.onQuantityChange);
          this.form?.removeEventListener('submit', this.onFormSubmit, true);
          this.cartUnsubscriber?.();
        }

        onSurfaceChange() {
          if (this.surfaceChoice !== 'needs-ferrofix' && this.checkbox) this.checkbox.checked = false;
          this.clearCartError();
          this.updateAvailability();
          this.renderState();
        }

        onSelectionChange() {
          this.clearCartError();
          this.renderState();
        }

        onQuantityChange() {
          this.updateAvailability();
          this.renderState();
        }

        get productQuantity() {
          const quantity = Number(this.quantityInput?.value) || 1;
          return Math.max(1, quantity);
        }

        get surfaceChoice() {
          return this.surfaceChoices.find((choice) => choice.checked)?.value || '';
        }

        getSelectedLineItem(productQuantity = this.productQuantity) {
          if (this.surfaceChoice !== 'needs-ferrofix' || !this.checkbox?.checked || this.checkbox.disabled) return null;

          return {
            id: this.dataset.addonVariantId,
            quantity: Number(this.dataset.packsPerProduct) * productQuantity,
          };
        }

        async onFormSubmit(event) {
          const crossSellLine = this.getSelectedLineItem();
          if (!crossSellLine || !this.form) return;

          event.preventDefault();
          event.stopImmediatePropagation();

          const productForm = this.form.closest('product-form');
          const submitButton = productForm?.querySelector('[type="submit"]');
          const spinner = productForm?.querySelector('.loading__spinner');
          if (!submitButton || submitButton.getAttribute('aria-disabled') === 'true') return;

          productForm?.handleErrorMessage();
          this.clearCartError();
          submitButton.setAttribute('aria-disabled', 'true');
          submitButton.classList.add('loading');
          spinner?.classList.remove('hidden');

          const formData = new FormData(this.form);
          const variantId = formData.get('id');
          const quantity = Number(formData.get('quantity')) || 1;
          const cart = productForm?.cart || document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          const sections = cart ? cart.getSectionsToRender().map((section) => section.id) : [];
          const requestBody = {
            items: [
              { id: variantId, quantity },
              {
                id: crossSellLine.id,
                quantity: Number(this.dataset.packsPerProduct) * quantity,
              },
            ],
          };

          if (sections.length > 0) {
            requestBody.sections = sections.join(',');
            requestBody.sections_url = window.location.pathname;
            cart.setActiveElement(document.activeElement);
          }

          try {
            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: JSON.stringify(requestBody),
            });
            const cartData = await response.json();

            if (!response.ok || cartData.status) {
              const message = cartData.description || cartData.message || this.dataset.cartErrorMessage;
              productForm?.handleErrorMessage(message);
              this.showCartError(message);

              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'dynarep-ferrofix-cross-sell',
                  productVariantId: variantId,
                  errors: cartData.errors || message,
                  message,
                });
              }
              return;
            }

            if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              await publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'dynarep-ferrofix-cross-sell',
                productVariantId: variantId,
                cartData,
              });
            }

            cart.renderContents(cartData);
            await this.refreshCart();
          } catch (error) {
            const message = this.dataset.cartErrorMessage;
            productForm?.handleErrorMessage(message);
            this.showCartError(message);
            console.error(error);
          } finally {
            submitButton.classList.remove('loading');
            if (cart?.classList.contains('is-empty')) cart.classList.remove('is-empty');
            submitButton.removeAttribute('aria-disabled');
            spinner?.classList.add('hidden');
          }
        }

        updateAvailability() {
          if (!this.checkbox) return;

          const isRelevant = this.surfaceChoice === 'needs-ferrofix';
          const available = this.dataset.addonAvailable === 'true';
          const inventoryManaged = this.dataset.inventoryManaged === 'true';
          const inventoryContinues = this.dataset.inventoryPolicy === 'continue';
          const inventoryQuantity = Number(this.dataset.inventoryQuantity) || 0;
          const requiredQuantity = Number(this.dataset.packsPerProduct) * this.productQuantity;
          const enoughInventory = !inventoryManaged || inventoryContinues || inventoryQuantity >= requiredQuantity;
          const canSelect = available && enoughInventory;

          this.checkbox.disabled = !isRelevant || !canSelect;
          if (!isRelevant || !canSelect) this.checkbox.checked = false;
          this.querySelector('[data-stock-message]')?.toggleAttribute('hidden', !isRelevant || canSelect);
        }

        async refreshCart() {
          try {
            const response = await fetch(window.Shopify.routes.root + 'cart.js');
            if (!response.ok) return;
            const cart = await response.json();
            this.cartTotal = Number(cart.total_price) || 0;
            this.currency = cart.currency || this.currency;
            this.renderState();
          } catch (error) {
            this.renderState();
          }
        }

        renderState() {
          if (!this.checkbox) return;

          const choice = this.surfaceChoice;
          const needsFerroFix = choice === 'needs-ferrofix';
          const selected = needsFerroFix && this.checkbox.checked && !this.checkbox.disabled;
          const productQuantity = this.productQuantity;
          const mainTotal = Number(this.dataset.mainPrice) * productQuantity;
          const addonTotal = selected
            ? Number(this.dataset.addonUnitPrice) * Number(this.dataset.packsPerProduct) * productQuantity
            : 0;
          const threshold = Math.max(1, Number(this.dataset.shippingThreshold));
          const projectedTotal = this.cartTotal + mainTotal + addonTotal;
          const missing = Math.max(0, threshold - projectedTotal);
          const progress = Math.min(100, (projectedTotal / threshold) * 100);

          this.dataset.choice = choice || 'unanswered';
          this.dataset.selected = selected ? 'true' : 'false';
          this.querySelector('[data-direct-result]')?.toggleAttribute('hidden', choice !== 'direct');
          this.querySelector('[data-addon-panel]')?.toggleAttribute('hidden', !needsFerroFix);
          this.querySelector('[data-selection-status]').textContent = selected
            ? this.dataset.statusSelected
            : needsFerroFix
              ? this.dataset.statusRecommended
              : this.dataset.statusUnselected;
          this.querySelector('[data-projected-total]').textContent = this.formatMoney(projectedTotal);
          this.querySelector('[data-shipping-missing-value]').textContent = this.formatMoney(missing);
          this.querySelector('[data-shipping-threshold]').textContent = this.formatMoney(threshold);

          const progressElement = this.querySelector('[data-shipping-progress]');
          progressElement?.setAttribute('aria-valuenow', String(Math.min(projectedTotal, threshold)));
          this.querySelector('[data-shipping-progress-bar]')?.style.setProperty('--dynarep-progress', `${progress}%`);
          this.querySelector('[data-shipping-missing]')?.toggleAttribute('hidden', missing === 0);
          this.querySelector('[data-shipping-success]')?.toggleAttribute('hidden', missing !== 0);
        }

        formatMoney(cents) {
          return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
            style: 'currency',
            currency: this.currency,
          }).format(cents / 100);
        }

        showCartError(message) {
          const error = this.querySelector('[data-cart-error]');
          if (!error) return;
          error.textContent = message;
          error.hidden = false;
        }

        clearCartError() {
          const error = this.querySelector('[data-cart-error]');
          if (!error) return;
          error.textContent = '';
          error.hidden = true;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dynarep-compatibility-cross-sell"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dynarep-ferrofix-cross-sell')) {
    customElements.define(
      'dynarep-ferrofix-cross-sell',
      class DynarepFerroFixCrossSell extends HTMLElement {
        connectedCallback() {
          this.checkbox = this.querySelector('[data-addon-checkbox]');
          this.surfaceChoices = [...this.querySelectorAll('[data-surface-choice]')];
          this.form = document.getElementById(this.dataset.productFormId);
          this.quantityInput = this.form?.elements.namedItem('quantity');
          this.cartTotal = Number(this.dataset.cartTotal) || 0;
          this.currency = this.dataset.currency || 'EUR';
          this.onSurfaceChange = this.onSurfaceChange.bind(this);
          this.onSelectionChange = this.onSelectionChange.bind(this);
          this.onQuantityChange = this.onQuantityChange.bind(this);
          this.onFormSubmit = this.onFormSubmit.bind(this);

          this.surfaceChoices.forEach((choice) => choice.addEventListener('change', this.onSurfaceChange));
          this.checkbox?.addEventListener('change', this.onSelectionChange);
          this.quantityInput?.addEventListener('change', this.onQuantityChange);
          this.quantityInput?.addEventListener('input', this.onQuantityChange);
          this.form?.addEventListener('submit', this.onFormSubmit, true);

          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.cartUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refreshCart());
          }

          this.updateAvailability();
          this.renderState();
          this.refreshCart();
        }

        disconnectedCallback() {
          this.surfaceChoices.forEach((choice) => choice.removeEventListener('change', this.onSurfaceChange));
          this.checkbox?.removeEventListener('change', this.onSelectionChange);
          this.quantityInput?.removeEventListener('change', this.onQuantityChange);
          this.quantityInput?.removeEventListener('input', this.onQuantityChange);
          this.form?.removeEventListener('submit', this.onFormSubmit, true);
          this.cartUnsubscriber?.();
        }

        onSurfaceChange() {
          if (this.surfaceChoice !== 'needs-ferrofix' && this.checkbox) this.checkbox.checked = false;
          this.clearCartError();
          this.updateAvailability();
          this.renderState();
        }

        onSelectionChange() {
          this.clearCartError();
          this.renderState();
        }

        onQuantityChange() {
          this.updateAvailability();
          this.renderState();
        }

        get productQuantity() {
          const quantity = Number(this.quantityInput?.value) || 1;
          return Math.max(1, quantity);
        }

        get surfaceChoice() {
          return this.surfaceChoices.find((choice) => choice.checked)?.value || '';
        }

        getSelectedLineItem(productQuantity = this.productQuantity) {
          if (this.surfaceChoice !== 'needs-ferrofix' || !this.checkbox?.checked || this.checkbox.disabled) return null;

          return {
            id: this.dataset.addonVariantId,
            quantity: Number(this.dataset.packsPerProduct) * productQuantity,
          };
        }

        async onFormSubmit(event) {
          const crossSellLine = this.getSelectedLineItem();
          if (!crossSellLine || !this.form) return;

          event.preventDefault();
          event.stopImmediatePropagation();

          const productForm = this.form.closest('product-form');
          const submitButton = productForm?.querySelector('[type="submit"]');
          const spinner = productForm?.querySelector('.loading__spinner');
          if (!submitButton || submitButton.getAttribute('aria-disabled') === 'true') return;

          productForm?.handleErrorMessage();
          this.clearCartError();
          submitButton.setAttribute('aria-disabled', 'true');
          submitButton.classList.add('loading');
          spinner?.classList.remove('hidden');

          const formData = new FormData(this.form);
          const variantId = formData.get('id');
          const quantity = Number(formData.get('quantity')) || 1;
          const cart = productForm?.cart || document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          const sections = cart ? cart.getSectionsToRender().map((section) => section.id) : [];
          const requestBody = {
            items: [
              { id: variantId, quantity },
              {
                id: crossSellLine.id,
                quantity: Number(this.dataset.packsPerProduct) * quantity,
              },
            ],
          };

          if (sections.length > 0) {
            requestBody.sections = sections.join(',');
            requestBody.sections_url = window.location.pathname;
            cart.setActiveElement(document.activeElement);
          }

          try {
            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: JSON.stringify(requestBody),
            });
            const cartData = await response.json();

            if (!response.ok || cartData.status) {
              const message = cartData.description || cartData.message || this.dataset.cartErrorMessage;
              productForm?.handleErrorMessage(message);
              this.showCartError(message);

              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'dynarep-ferrofix-cross-sell',
                  productVariantId: variantId,
                  errors: cartData.errors || message,
                  message,
                });
              }
              return;
            }

            if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              await publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'dynarep-ferrofix-cross-sell',
                productVariantId: variantId,
                cartData,
              });
            }

            cart.renderContents(cartData);
            await this.refreshCart();
          } catch (error) {
            const message = this.dataset.cartErrorMessage;
            productForm?.handleErrorMessage(message);
            this.showCartError(message);
            console.error(error);
          } finally {
            submitButton.classList.remove('loading');
            if (cart?.classList.contains('is-empty')) cart.classList.remove('is-empty');
            submitButton.removeAttribute('aria-disabled');
            spinner?.classList.add('hidden');
          }
        }

        updateAvailability() {
          if (!this.checkbox) return;

          const isRelevant = this.surfaceChoice === 'needs-ferrofix';
          const available = this.dataset.addonAvailable === 'true';
          const inventoryManaged = this.dataset.inventoryManaged === 'true';
          const inventoryContinues = this.dataset.inventoryPolicy === 'continue';
          const inventoryQuantity = Number(this.dataset.inventoryQuantity) || 0;
          const requiredQuantity = Number(this.dataset.packsPerProduct) * this.productQuantity;
          const enoughInventory = !inventoryManaged || inventoryContinues || inventoryQuantity >= requiredQuantity;
          const canSelect = available && enoughInventory;

          this.checkbox.disabled = !isRelevant || !canSelect;
          if (!isRelevant || !canSelect) this.checkbox.checked = false;
          this.querySelector('[data-stock-message]')?.toggleAttribute('hidden', !isRelevant || canSelect);
        }

        async refreshCart() {
          try {
            const response = await fetch(window.Shopify.routes.root + 'cart.js');
            if (!response.ok) return;
            const cart = await response.json();
            this.cartTotal = Number(cart.total_price) || 0;
            this.currency = cart.currency || this.currency;
            this.renderState();
          } catch (error) {
            this.renderState();
          }
        }

        renderState() {
          if (!this.checkbox) return;

          const choice = this.surfaceChoice;
          const needsFerroFix = choice === 'needs-ferrofix';
          const selected = needsFerroFix && this.checkbox.checked && !this.checkbox.disabled;
          const productQuantity = this.productQuantity;
          const mainTotal = Number(this.dataset.mainPrice) * productQuantity;
          const addonTotal = selected
            ? Number(this.dataset.addonUnitPrice) * Number(this.dataset.packsPerProduct) * productQuantity
            : 0;
          const threshold = Math.max(1, Number(this.dataset.shippingThreshold));
          const projectedTotal = this.cartTotal + mainTotal + addonTotal;
          const missing = Math.max(0, threshold - projectedTotal);
          const progress = Math.min(100, (projectedTotal / threshold) * 100);

          this.dataset.choice = choice || 'unanswered';
          this.dataset.selected = selected ? 'true' : 'false';
          this.querySelector('[data-direct-result]')?.toggleAttribute('hidden', choice !== 'direct');
          this.querySelector('[data-addon-panel]')?.toggleAttribute('hidden', !needsFerroFix);
          this.querySelector('[data-selection-status]').textContent = selected
            ? this.dataset.statusSelected
            : needsFerroFix
              ? this.dataset.statusRecommended
              : this.dataset.statusUnselected;
          this.querySelector('[data-projected-total]').textContent = this.formatMoney(projectedTotal);
          this.querySelector('[data-shipping-missing-value]').textContent = this.formatMoney(missing);
          this.querySelector('[data-shipping-threshold]').textContent = this.formatMoney(threshold);

          const progressElement = this.querySelector('[data-shipping-progress]');
          progressElement?.setAttribute('aria-valuenow', String(Math.min(projectedTotal, threshold)));
          this.querySelector('[data-shipping-progress-bar]')?.style.setProperty('--dynarep-progress', `${progress}%`);
          this.querySelector('[data-shipping-missing]')?.toggleAttribute('hidden', missing === 0);
          this.querySelector('[data-shipping-success]')?.toggleAttribute('hidden', missing !== 0);
        }

        formatMoney(cents) {
          return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
            style: 'currency',
            currency: this.currency,
          }).format(cents / 100);
        }

        showCartError(message) {
          const error = this.querySelector('[data-cart-error]');
          if (!error) return;
          error.textContent = message;
          error.hidden = false;
        }

        clearCartError() {
          const error = this.querySelector('[data-cart-error]');
          if (!error) return;
          error.textContent = '';
          error.hidden = true;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
